import { useEffect } from 'react';

import { useAuth, useOrganization, useOrganizationList } from '@clerk/react';

interface OrganizationProviderProps {
  children: React.ReactNode;
}

export const OrganizationProvider: React.FC<OrganizationProviderProps> = ({ children }) => {
  const { isLoaded: isAuthLoaded, isSignedIn } = useAuth();
  const { organization, isLoaded: isOrgLoaded } = useOrganization();
  const { setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true
    }
  });

  useEffect(() => {
    const isReady = isAuthLoaded && isOrgLoaded && isSignedIn;
    const needsOrganization = isReady && !organization;

    if (!needsOrganization) {
      return;
    }

    const firstOrg = userMemberships.data?.[0]?.organization;

    if (!firstOrg) {
      console.error(
        '[OrganizationProvider] User has no organizations. Multi-tenancy requires organization membership.'
      );
      return;
    }

    void setActive?.({ organization: firstOrg.id });
  }, [isAuthLoaded, isOrgLoaded, isSignedIn, organization, userMemberships.data, setActive]);

  return <>{children}</>;
};
